import {
  AuthConfig as OAuthConfig,
  OAuthModuleConfig,
} from 'angular-oauth2-oidc';
import { InjectionToken } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';

export interface AuthConfig {
  oAuthConfig?: OAuthConfig;
  authModuleConfig: OAuthModuleConfig;
  storagePrefix: string;
  initialize: boolean;
  setSentryUser: boolean;
}

export const AUTH_CONFIG: InjectionToken<AuthConfig> =
  new InjectionToken<AuthConfig>('AUTH_CONFIG');

export interface UserProfileRealmAccess {
  roles: string[];
}

export interface UserProfile {
  acr: string;
  at_hash: string;
  aud: string;
  auth_time: number;
  azp: string;
  email: string;
  email_verified: boolean;
  exp: number;
  first_name: string;
  full_name: string;
  iat: number;
  id: string;
  iss: string;
  jti: string;
  last_name: string;
  nonce: string;
  person_id: string;
  preferred_username: string;
  roles?: string[];
  realm_access?: UserProfileRealmAccess;
  session_state: string;
  sid: string;
  skoleo_id: number;
  sub: string;
  typ: string;
}

export const SKIP_BEARER_TOKEN: HttpContextToken<boolean> =
  new HttpContextToken<boolean>(() => false);
